export const getMeetingMenu = ({
  enableGuest,
  addAlternativeHost,
  enableJoinBeforeHost,
  copyMeetingInvitation,
  deleteCalendarEntry,
  createCalendarEntry,
  addCodecs,
  removeCodecs,
}) => {
  return [
    {
      handler: enableGuest,
      title: 'Enable Guest Speaker',
    },
    {
      handler: addAlternativeHost,
      title: 'Add Alternative Host',
    },
    {
      handler: enableJoinBeforeHost,
      title: 'Enable join before host',
    },
    {
      handler: copyMeetingInvitation,
      title: 'Copy Meeting Invitation',
    },
    {
      handler: deleteCalendarEntry,
      title: 'Delete Calendar Entry',
    },
    {
      handler: createCalendarEntry,
      title: 'Create Calendar Entry',
    },
    {
      handler: addCodecs,
      title: 'Add Codecs',
    },
    {
      handler: removeCodecs,
      title: 'Remove Codecs',
    },
  ];
};
